export const formatNumberCpf = (number: string) => {
  return number.replace(/[^0-9]/g, '');
};
